import React,{ useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Input, Button, message, Popconfirm, Tag, Checkbox } from 'antd';
import { withTranslation } from 'react-i18next';
import { JOB_DETAILS_UI } from '../TranslationValues';
import regex from '../../../../../utils/regex';
import { useCallback } from 'react';
import { BATCH_REJECTION_MODAL } from '../../TranslationValues';
import { OverLay } from './styles';

const { TextArea } = Input;

const NAMESPACES = ['JOB_DETAILS_UI', 'BATCH_REJECTION_MODAL' ];

const RejectionComment = ({children, handleReject, onCancelRejection, open, type, t}) => {
  const [rejectionComments, setRejectionComments] = useState('');
  const [mailAddress, setMailAddress] = useState([]);
  const [isNotified, setIsNotified] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = useCallback(
    event => {
      event.preventDefault();
      const inputVal = event.target.value.trim();
      if (inputVal.length < 1) {
        return;
      }
      const isValidEmailID = regex.EMAIL.test(inputVal);
      if (isValidEmailID) {
        if (mailAddress.includes(inputVal)) {
          message.error(t(BATCH_REJECTION_MODAL.EMAIL_ID_EXISTS_ERROR.key, BATCH_REJECTION_MODAL.EMAIL_ID_EXISTS_ERROR.value));
        } else {
          setInputValue('');
          setMailAddress(prev => [...prev, inputVal]);
        }
      } else {
        message.warning(t(BATCH_REJECTION_MODAL.INVALID_EMAIL_ID_ERROR.key, BATCH_REJECTION_MODAL.INVALID_EMAIL_ID_ERROR.value));
      }
    },
    [mailAddress],
  );

  const handleClose = (email) => {
    setMailAddress(prev => prev.filter(e => e !== email));
  };

  const onConfirm = async () => {
    if (rejectionComments.trim().length === 0) {
      message.error(type === 'reject'
        ? t(JOB_DETAILS_UI.REJECTION_COMMENT_MANDATORY.key, JOB_DETAILS_UI.REJECTION_COMMENT_MANDATORY.value)
        : t(JOB_DETAILS_UI.ABORT_COMMENT_MANDATORY.key, JOB_DETAILS_UI.ABORT_COMMENT_MANDATORY.value)
      );
      return;
    }

    if (isNotified && mailAddress.length === 0) {
      message.warning(t(BATCH_REJECTION_MODAL.ENTER_EMAIL_ADDRESS.key, BATCH_REJECTION_MODAL.ENTER_EMAIL_ADDRESS.value));
      return;
    }

    handleReject({
      reason: rejectionComments,
      email: isNotified ? mailAddress : [],
      isNotified
    });
  };
  return (
    <>
      {open &&
        ReactDOM.createPortal(
          <OverLay />,
          document.body
        )
      }
      <Popconfirm
        visible={open}
        icon={null}
        title={
          <div style={{ width: 350, marginRight: '20px' }}>
            <label style={{ fontWeight: 600 }}>
              {t(JOB_DETAILS_UI.REJECTION_COMMENT.key, JOB_DETAILS_UI.REJECTION_COMMENT.value)}
            </label>

            <TextArea
              style={{ marginTop: 8, marginBottom: 8 }}
              rows={3}
              value={rejectionComments}
              onChange={(e) => setRejectionComments(e.target.value)}
            />

            <Checkbox
              checked={isNotified}
              onChange={() => setIsNotified(prev => !prev)}
              style={{ marginBottom: 8 }}
            >
              Notify Users
            </Checkbox>

            {isNotified && (
              <div style={{ border: '1px solid #ddd', padding: 8 }}>
                {mailAddress.map(email => (
                  <Tag
                    key={email}
                    closable
                    onClose={() => handleClose(email)}
                    color="#df4c35"
                  >
                    {email}
                  </Tag>
                ))}

                <Input
                  style={{ marginTop: '5px' }}
                  value={inputValue}
                  placeholder={t(JOB_DETAILS_UI.ENTER_EMAIL_PLACEHOLDER.key, JOB_DETAILS_UI.ENTER_EMAIL_PLACEHOLDER.value)}
                  onChange={(e) => setInputValue(e.target.value)}
                  onPressEnter={handleInputChange}
                />
              </div>
            )}
          </div>
        }
        onConfirm={onConfirm}
        onCancel={onCancelRejection}
        okText={t(JOB_DETAILS_UI.CONFIRM_BUTTON.key, JOB_DETAILS_UI.CONFIRM_BUTTON.value)}
        cancelText={t(JOB_DETAILS_UI.CANCEL.key, JOB_DETAILS_UI.CANCEL.value)}
        okButtonProps={{ size: 'default', style: { backgroundColor: 'red !important', color: 'white', width: 'auto' } }}
        cancelButtonProps={{ size: 'default', style: { backgroundColor: 'white', color: 'black', width: 'auto' } }}
      >{children}</Popconfirm>
    </>
  );
};

export default withTranslation(NAMESPACES)(RejectionComment);